
import React from 'react';

/**
 * ScrollProgressIndicator component
 * 
 * Displays a horizontal progress bar at the top of the page that visually 
 * indicates how far the user has scrolled through the content.
 * 
 * @param {number} progress - Percentage value (0-100) representing scroll position
 * @returns {JSX.Element} A fixed position progress bar that updates based on scroll position
 */
interface ScrollProgressIndicatorProps {
  progress: number;
}

const ScrollProgressIndicator: React.FC<ScrollProgressIndicatorProps> = ({ progress }) => {
  return (
    <div className="fixed top-0 left-0 right-0 h-1 z-50 bg-gray-800">
      <div 
        className="h-full bg-gradient-to-r from-blue-500 to-blue-300 transition-all duration-300 ease-out"
        style={{ width: `${progress}%` }}
        aria-hidden="true"
        role="progressbar"
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
      />
    </div>
  );
};

export default ScrollProgressIndicator;
